export const NAME = "Nombre";
export const CC = "Identificación";
export const OPTIONS = "Opciones";

export const Fields = [NAME, CC, OPTIONS];
